/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var useDidMount = require('./useDidMount.js');

var useWillUnmount = require('./useWillUnmount.js');

var useLifecycle = function useLifecycle(mount, unmount) {
  var onDidMount = useDidMount.default(mount);
  var onWillUnmount = useWillUnmount.default(unmount);
  return {
    onDidMount: onDidMount,
    onWillUnmount: onWillUnmount
  };
};

exports.default = useLifecycle;